import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryAttachableWorkerPoolsInSpaceArgs, WorkerPool } from "types/generated";

type AttachableWorkerPool = Pick<WorkerPool, "id" | "name">;

export const GET_ATTACHABLE_WORKER_POOLS_FOR_SCAN: TypedDocumentNode<
  { attachableWorkerPoolsInSpace: AttachableWorkerPool[] },
  QueryAttachableWorkerPoolsInSpaceArgs
> = gql`
  query GetAttachableWorkerPoolsForScan($id: ID!) {
    attachableWorkerPoolsInSpace(id: $id) {
      id
      name
    }
  }
`;
